import domready from "domready";
var navigationSwitch = 840;
var navigationChange = new CustomEvent("navigationChange");
var navigationLoad = new CustomEvent("navigationLoad");
var viewport;
function updateNavClass() {
  window.navigationViewport = window.innerWidth < navigationSwitch ? "mobile" : "desktop";
}
function fireNavigationChangeEvent() {
  document.body.dispatchEvent(navigationChange);
  window.dispatchEvent(navigationChange);
}
function valueChange(value, comparisonValue) {
  if (value != comparisonValue) {
    fireNavigationChangeEvent();
    return viewport = value;
  }
}
domready(function () {
  window.addEventListener("orientationchange", function () {
    valueChange(window.navigationViewport, viewport);
  });
  window.addEventListener("resize", function () {
    valueChange(window.navigationViewport, viewport);
    updateNavClass();
  });
  updateNavClass();
  viewport = window.navigationViewport;
});
